import type { ModuleDataSource, ModuleRow, OperationsModuleConfig } from './types';

function cloneRows(rows: ModuleRow[]) {
  return rows.map((row) => ({ ...row }));
}

export class LocalModuleDataSource implements ModuleDataSource {
  async load(config: OperationsModuleConfig) {
    try {
      const saved = localStorage.getItem(config.storageKey);
      return saved ? JSON.parse(saved) as ModuleRow[] : cloneRows(config.seed);
    } catch {
      return cloneRows(config.seed);
    }
  }

  async save(config: OperationsModuleConfig, rows: ModuleRow[]) {
    localStorage.setItem(config.storageKey, JSON.stringify(rows));
  }

  async sync(config: OperationsModuleConfig, rows: ModuleRow[]) {
    const existing = new Set(rows.map((row) => row.id));
    const additions = (config.syncRows ?? []).filter((row) => !existing.has(row.id));
    return [...additions.map((row) => ({ ...row })), ...rows];
  }
}

export const moduleDataSource: ModuleDataSource = new LocalModuleDataSource();
